var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    _vm._b({}, "v-row", _vm.$attrs, false),
    [
      _vm.inactiveService
        ? _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c("hosting-pending", {
                attrs: {
                  status: _vm.hosting.status
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "pt-4 pl-3 pr-3",
          staticStyle: {
            display: "grid",
            "grid-template-columns": "repeat(auto-fit, minmax(270px, 1fr))",
            gap: "24px",
            width: "100%"
          }
        },
        [
          _vm.showAccounts
            ? _c("thin-card", {
                attrs: {
                  title: "Account Usage",
                  text: _vm.accountsQty,
                  icon: "mdi-account-multiple"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "append",
                      fn: function fn() {
                        return [
                          _c(
                            "v-progress-circular",
                            {
                              attrs: {
                                size: 50,
                                rotate: -90,
                                width: 7,
                                value: _vm.accountsQtyPercent,
                                color: "primary"
                              }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.accountsQtyPercent) + "% "
                              )
                            ]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  154146988
                )
              })
            : _vm._e(),
          _c("thin-card", {
            attrs: {
              title: "Disk Space Usage",
              text: _vm.spaceUsed,
              icon: "mdi-harddisk"
            },
            scopedSlots: _vm._u([
              {
                key: "append",
                fn: function fn() {
                  return [
                    _c(
                      "v-progress-circular",
                      {
                        attrs: {
                          size: 50,
                          rotate: -90,
                          width: 7,
                          value: _vm.spaceUsedPercent,
                          color: "primary"
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.spaceUsedPercent) + "% ")]
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _c("thin-card", {
            attrs: {
              title: "Bandwidth Usage",
              text: _vm.bandwidthUsage,
              icon: "mdi-upload"
            },
            scopedSlots: _vm._u([
              {
                key: "append",
                fn: function fn() {
                  return [
                    _c(
                      "v-progress-circular",
                      {
                        attrs: {
                          size: 50,
                          rotate: -90,
                          width: 7,
                          value: _vm.bandwidthPercent,
                          color: "primary"
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.bandwidthPercent) + "% ")]
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _c("thin-card", {
            staticStyle: {
              flex: "0 0 calc((100% - 3 * 24px) / 4)"
            },
            attrs: {
              title: "Inode Usage",
              text: _vm.inodeUsed,
              icon: "mdi-chart-bar"
            },
            scopedSlots: _vm._u([
              {
                key: "append",
                fn: function fn() {
                  return [
                    _c(
                      "v-progress-circular",
                      {
                        attrs: {
                          size: 50,
                          rotate: -90,
                          width: 7,
                          value: _vm.inodeUsedPercent,
                          color: "primary"
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.inodeUsedPercent) + "% ")]
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }